import React, { useEffect, useState } from 'react'
import { Circle, FiberManualRecord } from '@mui/icons-material'

import QRCode from "react-qr-code";
import moment from 'moment';

function BottomNewsComponent({displayInfo}) {
    const [today, setDate] = useState(new Date());
    let portald = localStorage.getItem("portalId");;
    const url = "https://me.gtoken.in/portal/"+portald
    useEffect(()=>{
        const timer = setInterval(() => { // Creates an interval which will update the current data every minute
            // This will trigger a rerender every component that uses the useDate hook.
            setDate(new Date());
        }, 60 * 1000);
        return () => {
            clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
        }
    },[])
    return (

        displayInfo?.newsList.length > 0 &&
            <div style={{position:"fixed", bottom:0,left:0, backgroundColor:"#300", width:"100%", height:"100px"}} >
                <div className="row" style={{height:"100px"}}>
                    <div className="col-3 bg-info shadow text-center pt-0 shadow ">
                        <div className='row'>
                            <div className='col-md-9 pt-2'>
                                <h4 style={{lineHeight:1}} className='fw-bold'>{displayInfo?.portalDetails.title} </h4>
                                <h5 style={{lineHeight:1}}>Scan me to be in queue</h5>
                                <p>{moment(today).format("LLL")}</p>
                            </div>
                            <div className='col-md-3'>
                                <QRCode
                                    size={256}
                                    style={{ height: "auto", maxWidth: "100px", width: "100%" }}
                                    value={url}
                                    viewBox={`0 0 256 256`}
                                />
                            </div>
                        </div>
                    </div>
                    <div  className="col-9 bg-dark text-white shadow  pt-4 ps-0 shadow ">
                        <marquee> 
                            {displayInfo?.newsList.map(news=>
                                <span key={news.id} className="me-2" style={{fontSize:30,fontWeight:"bold"}}>{news.details} <FiberManualRecord  fontSize="small"/></span>
                            )}
                        </marquee>
                    </div>
                </div>
            </div>
    )
}

export default BottomNewsComponent